// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".estimate-page .navbar .nav-link i[class^=cus-]{margin-top:0!important;margin-right:.2em!important}", ""]);
// Exports
module.exports = exports;
